const messages = {
  title: "Prejeta pošta",
  desc: "Tu boste našli pomembna obvestila in novice.",
  newMessages: "Nova sporočila v prejeti pošti",
  link: "Prikaži sporočila",
  showMessages: "Prikaži sporočila",
  message: {
    sender: "Pošiljatelj",
    thread: "Zadeva",
    date: "Datum",
  },
  sender: {
    system: "BRIDGESTONE PLUS",
    admin: "Admin",
  },
  back: "Nazaj",
  time: {
    secondsAgo: "pred {time} sekundami",
    minutesAgo: "pred {time} minutami",
    hoursAgo: "pred {time} urami",
    daysAgo: "pred {time} dnevi",
  },
};
export default {
  messages,
};
